import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const selector = (state: ApplicationState) => {
    return getCurrentPage(state);
};
